
import axios from "axios";
import apiUrl from "../apiUrlConstant";

const TOKEN_KEY = 'user';

export const login = () => {
   // localStorage.setItem(TOKEN_KEY, 'TestLogin');
}

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
}

export const hasAccess = ( arr = [] , param  = '') => {
    var userData =  JSON.parse(localStorage.getItem(TOKEN_KEY));
    if( arr.length > 0 && userData != null && arr.includes(userData.role) ) {
        return true;
    }else{
        if(typeof arr == "undefined" || arr.length == 0) {
            return true;
        }else{
            return false;
        }
    }
}
export const clientAccess = ( ) => {
    var userData =  JSON.parse(localStorage.getItem('user'));
    if(userData.clientId!=null && userData.clientId==100){
        return true;
    }
    
    if(userData.clientId!=null && userData.clientId >0){
        return false;
    }else{
        return true;
    }
}
export const clientId = ( ) => {
    var userData =  JSON.parse(localStorage.getItem('user'));
    var clientId =  (userData != null && typeof userData.clientId != "undefined") ? userData.clientId : 0; 
    return(clientId);
}
export const isLogin = () => {
    return localStorage.getItem(TOKEN_KEY) ? true : false;   
}


export const getUserType = () => {
    var userData = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if(typeof userData != "undefined" && userData != null) {
        return userData.clientCategory;
    }
    return false;
}

export const fileUploadPath = () => {
    var parts = window.location.hostname.split('.');
    var sndleveldomain = parts.slice(-0).join('.');
    return sndleveldomain + "/";
}




export const getUserRole = () => {
    var userData = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if(typeof userData != "undefined" && userData != null) {
        return userData.role;
    }
    return false;
}

export const getUserCategory = () => {
    var userData = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if(typeof userData != "undefined" && userData != null) {
        //return userData.platform;
        return userData.platform.charAt(0).toUpperCase() + userData.platform.slice(1);
    }
    return false;
}

export const getUserStorageType = () => {
    var userData = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if(typeof userData != "undefined" && userData != null) {
        return userData.storageType;
    }
    return false;
}

export const getLeadCategories = () => {
    return {
        'active':"Active Lead",
        'inactive':"Inactive Lead"
    };
}

export const getLeadSubCategories = () => {
    return axios({
        method: "get",
        url: apiUrl.apiUrl.url + '/leads/get-substage-by-category',
    }).then(function (response) {
        return response.data.data;
    });

    // return {
    //     "Active Lead":['Pitching','Planning','Site Visit','Proposal','Won'],
    //     "Inactive Lead":['Junk','Lost']
    // };
}

export const generateRandomFilename = (filename) => {
    const ext = filename.split('.').pop();
    const randomString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    return `${randomString}.${ext}`;
}

export const numberFormat = (value) => {
    return Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getModules = () => {
    var userData = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if(typeof userData != "undefined" && userData != null) {
        return userData.modules;
    }
    return false;
}

export const getDashboard = () => {
    var userData = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if(typeof userData != "undefined" && userData != null) {
        return userData.dashboard;
    }
    return false;
}

export const getLeadStatus = () => {
    return ['cold','Dropped','hot','Leased','Warm','Query','Sold'];
}